import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TxtAdd } from '../interfaces/txtAdd';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class TxtAddService {  

  // A base vem da sessao (jwtAuthService), nao do environment: quando o usuario opera
  // em outra empresa, a URL acompanha. Com a constante do environment, esta tela
  // falava sempre com a mesma API, independente de onde a sessao estivesse.
  readonly path = '/texto/adicional';

  get url(): string {
    return this.jwtAuthService.apiUrl + this.path;
  }

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cadastro: TxtAdd): Observable<TxtAdd> {
    return this.http.put<TxtAdd>(`${this.url}`, cadastro);
  }

  getTxtAdd(id: number ): Observable<TxtAdd> {
    return this.http.get<TxtAdd>(`${this.url}/${id}`);
  }

  getTxtAddPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<TxtAdd>> {
    const params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    return this.http.get<PageResult<TxtAdd>>(`${this.url}/page/get/`, { params });
  }

  getTxtAddPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<TxtAdd>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<PageResult<TxtAdd>>(`${this.url}/page/get/`, { params });
  }

  doesCodeExist(code: any, uuid: string) {
    return this.http.get<boolean>(`${this.url}/${code}?uuid=${uuid}`);
  }

}
